import { toastError } from '../../helper'
import { AUTH_ACTIONS } from '../context/auth/AUTH_ACTIONS'
import { useAuthContext } from '../context/auth/AuthProvider'
import AuthService from '../services/AuthService'

export default function useAuthActions() {
  const { authDispatch } = useAuthContext()

  async function getCurrentUser() {
    try {
      authDispatch({
        type: AUTH_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await AuthService.getCurrentUser()

      authDispatch({
        type: AUTH_ACTIONS.SET_CURRENT_USER,
        payload: {
          user: data.user,
        },
      })
    } catch (error) {
      // throw error
    } finally {
      authDispatch({
        type: AUTH_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function login(payload) {
    try {
      const { data } = await AuthService.login(payload)
      authDispatch({
        type: AUTH_ACTIONS.SET_CURRENT_USER,
        payload: {
          user: data.user
        },
      })
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    }
  }
  async function logout() {
    try {
      await AuthService.logout()
      authDispatch({
        type: AUTH_ACTIONS.SET_CURRENT_USER,
        payload: {
          user: null,
        },
      })
    } catch (error) {
      throw error
    }
  }
  return { login, getCurrentUser,logout }
}
